module.exports = __webpack_public_path__ + "media/images/sales/early/badge-point-01-d25463ac126c219ed94ebb79c550db8a.svg";